import React, { useContext, useEffect, useState, useCallback } from "react";
import useSnackbar from "./../../../hooks/useSnackbar";
import _ from "lodash";

import {
  Button,
  Divider,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  colors,
  Paper,
  IconButton,
  TextField,
  Checkbox,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  Collapse
} from "@mui/material";

import { useTheme } from "@mui/material/styles";

import AdsSettingPanel from "./AdsSettings/AdsSettingPanel";

import { KEY_NAME_REGEX } from "../../../constants";

import HttpContext from "../../../contexts/HTTP/HttpContext";

import moment from "moment";

import { WORKFLOW_MODES } from "../../../constants";

function AdsSettings() {
  const theme = useTheme();
  const { get, post } = useContext(HttpContext);

  const [loading, setLoading] = useState(true);

  const [editDialogIsOpened, setEditDialogIsOpened] = useState(false);
  const [editDialogData, setEditDialogData] = useState(null);
  const [editDialogIndex, setEditDialogIndex] = useState(null);

  const [adsConfiguration, setAdsConfiguration] = useState(null);

  const [hasChange, setHasChange] = useState(false);
  const stableSetHasChange = useCallback(value => {
    setHasChange(value);
  }, []);

  const [themeDialogOpen, setThemeDialogOpen] = useState(false);

  const { openSnackbar } = useSnackbar();

  const loadData = async () => {
    setLoading(true);

    //Load data
    const res2 = await get("/kiosk/adsConfiguration");
    console.log("[AdsSettings] res2", res2);

    if (res2.status !== 200) {
      openSnackbar({
        open: true,
        message: "Unable to load Ads settings",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });
    }

    if (res2.status == 403 || res2.status == 401) {
      //logout and redirect to login
      await get("/logout");
      localStorage.removeItem("accessToken");
      window.location.href = "/login";
    }

    if (res2.status === 200) {
      const data = _.get(res2, "data");
      console.log("[AdsSettings] data", data);

      await setAdsConfiguration(data);
    }

    setHasChange(false);
    setLoading(false);
  };

  const saveSettings = useCallback(async newpayload => {
    //const newsettings = { ...serverSetting, theme: newtheme };
    console.log("DEBUG [saveSettings] newpayload", newpayload);

    const res2 = await post("/kiosk/adsConfiguration", newpayload);
    if (res2.status === 200) {
      const subscriptionData = _.get(res2, "data");

      //SInce format can change, just reload from server
      openSnackbar({
        open: true,
        message: "Successfully updated!",
        variant: "alert",
        alert: {
          color: "success"
        },
        close: false
      });
      await loadData();

      // await setServerSetting(subscriptionData);
    }
  }, []);

  useEffect(() => {
    (async () => {
      await loadData();
    })();
  }, []);

  return (
    <Grid
      style={{
        margin: theme.spacing(2),
        padding: theme.spacing(3),
        width: "100%",
        backgroundColor: colors.grey[100],
        borderRadius: "10px"
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="h4">Ads Setting</Typography>
        </div>
      </div>

      {adsConfiguration !== undefined && adsConfiguration !== null ? (
        <AdsSettingPanel
          initialAdsConfiguration={adsConfiguration}
          open={themeDialogOpen}
          hasChange={hasChange}
          setHasChange={stableSetHasChange}
          loading={loading}
          handleSaveEditChanges={async newtheme => {
            console.log("newtheme", newtheme);

            await saveSettings({ ...adsConfiguration, theme: newtheme });
          }}
        />
      ) : (
        <TableBody>Loading</TableBody>
      )}
    </Grid>
  );
}

export default AdsSettings;

function isKeyNameValid(name) {
  if (!name) return false;

  return KEY_NAME_REGEX.test(name);
}

function isKeyNameDuplicate(keys, name) {
  return keys.map(key => key.name).includes(name);
}

function getKeyNameHelperText(keys, name) {
  if (!isKeyNameValid(name)) {
    return "Invalid name";
  }

  if (isKeyNameDuplicate(keys, name)) {
    return "Name already in use";
  }

  return "";
}
